import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useMutationMeTag } from 'gql/mutations/me';
import { trackEvent } from 'lib/tracking';

import TutorialsPopUp from './TutorialsPopUp';

const TutorialsPopUpContainer = () => {
  const { t } = useTranslation();
  const mutationMeTag = useMutationMeTag();
  const handlePopUpClose = useCallback(async () => {
    try {
      await mutationMeTag(['tutorials']);
      trackEvent('tag', 'tutorials');
    } catch (err) {
      reportError('tag', 'tutorials', err);
    }
  }, [mutationMeTag]);
  return <TutorialsPopUp handlePopUpClose={handlePopUpClose} t={t} />;
};

export default TutorialsPopUpContainer;
